import {
  CreateFleetRequest,
  CreateFleetResponse,
  DeleteFleetRequest,
  SharedItem,
  SharedItemShareType,
  SharedItemsResponse,
  UpdateEquipmentUserPermissionsRequest,
  UpdateFleetRequest,
  AddNewUserRequest,
} from './types';
import { secureApi } from 'services/api';

export const initialSharesState: SharedItemsResponse = {
  equipment: [],
  fleets: [],
};

export const sharesApi = secureApi.injectEndpoints({
  endpoints: builder => ({
    createFleet: builder.mutation<CreateFleetResponse, CreateFleetRequest>({
      query: data => ({
        url: '/apiv2/user/fleet',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['SharedItem'],
    }),

    updateFleet: builder.mutation<CreateFleetResponse, UpdateFleetRequest>({
      query: data => ({
        url: '/apiv2/user/fleet',
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['SharedItem'],
    }),

    deleteFleet: builder.mutation<void, DeleteFleetRequest>({
      query: data => ({
        url: '/apiv2/user/fleet',
        method: 'DELETE',
        data,
      }),
      invalidatesTags: ['SharedItem'],
    }),

    updateUserPermissions: builder.mutation<
      void,
      UpdateEquipmentUserPermissionsRequest
    >({
      query: data => ({
        url: '/apiv2/user/share',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['SharedItem', 'Invitation'],
    }),

    addNewUser: builder.mutation<void, AddNewUserRequest>({
      query: data => ({
        url: '/apiv2/user/share',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Invitation', 'SharedItem'],
    }),

    getShares: builder.query<SharedItemsResponse, void>({
      query: () => ({
        url: '/apiv2/user/share',
        method: 'GET',
      }),

      transformResponse: (response: SharedItem[]) => {
        const equipment =
          response.filter(
            item =>
              item.sharedItemDetails.shareType ===
              SharedItemShareType.EQUIPMENT,
          ) ?? [];
        const fleets =
          response.filter(
            item =>
              item.sharedItemDetails.shareType === SharedItemShareType.FLEET,
          ) ?? [];
        return { equipment, fleets };
      },

      transformErrorResponse: () => initialSharesState,

      providesTags: result =>
        result
          ? [
              ...result.equipment.flatMap(item => [
                {
                  id: item.sharedItemDetails.exposedId,
                  type: 'SharedItem' as const,
                },
              ]),
              'SharedItem',
            ]
          : [],
    }),
  }),
  overrideExisting: true,
});
